import React from 'react';
import { AstraPayLogo } from 'ui/assets/icons';
import { Arrow, FillProfileIcon, TextFromDeviceIcon } from 'ui/components/atoms/Icons';
import PersonAddIcon from '../../atoms/Icons/PersonAddIcon';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import { IRootState } from '../../../store';
import FillProfileIconDisabled from '../../atoms/Icons/FillProfileIconDisabled';
import AstraPayLogoDisabled from '../../../assets/icons/astraPayLogoDisabled';
import useGetBalanceAstrapay from '../../../hooks/useGetBalanceAstrapay';
import eventClickUpdateProfileLoyalti from '../../../lib/gtm/eventMyAccount/eventClickUpdateProfileLoyalti';
import eventClickBookingServiceMyAccount from '../../../lib/gtm/eventMyAccount/eventClickBookingServiceMyAccount';

const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;

export default function LoyaltyProgramSection({
  isLogin = undefined,
  astrapointsValue,
}: {
  isLogin?: boolean | undefined;
  astrapointsValue: string;
}) {
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth);

  const { isAstrapayConnected } = useGetBalanceAstrapay();

  return (
    <div data-test-id="cta-container" className="border-[1px] rounded-md">
      <div className="relative p-3 rounded-t-md bg-[#036EBC] overflow-hidden">
        <div className="absolute top-0 right-0 mix-blend-multiply">
          <TriangleBannerTop />
        </div>

        <div className="absolute bottom-0 right-[-5px] w-24 h-full mix-blend-multiply">
          <TriangleBannerBottom />
        </div>

        <div className="flex gap-1.5 relative z-10">
          <div>
            <TextFromDeviceIcon />
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-sm font-semibold w-[266px] text-white">
              Yuk lengkapi Profile AutoFamily dan
              <br />
              dapatkan {astrapointsValue} AstraPoints!
            </span>
            <span className="text-xs w-[266px] text-white">
              Untuk layanan terbaik yang lebih personal bersama Auto2000
            </span>
          </div>
        </div>
      </div>
      <div className="p-4 flex flex-col gap-3">
        {!isLogin && (
          <Link
            className="flex p-3 justify-between border-[1px] rounded-lg cursor-pointer"
            aria-disabled={!isAuth}
            href={!isAuth ? '#' : `${PUBLIC_URL}/login`}
            onClick={() =>
              eventClickBookingServiceMyAccount({
                params: 'registrasi akun digiroom',
                eventName: 'registrasi_akun_digiroom_button',
                eventCategory: 'loyalty digiroom',
              })
            }
          >
            <div className="flex gap-3">
              <PersonAddIcon width="18" height="18" />
              <div className="flex flex-col gap-1">
                <span className="font-bold text-xs text-[#4F4C4D] text-start">
                  Registrasi Akun Digiroom
                </span>
                <span className="text-xs text-[#7B7979] text-start">
                  Daftar dan verifikasi Akun Digiroom
                </span>
              </div>
            </div>
            <div data-test-id="cta-buttons-container-lengkapi-profile-arrow" className="my-auto">
              <Arrow direction="right" color="black" size={18} fillOpacity={0.54} />
            </div>
          </Link>
        )}

        {!userData?.isProfileCompleteOnline && (
          <Link
            className={`flex p-3 justify-between border-[1px] rounded-lg cursor-pointer ${!isLogin && 'bg-reliableBlack5 !cursor-not-allowed'}`}
            aria-disabled={!isLogin}
            href={!isLogin ? '#' : `${PUBLIC_URL}/myaccount/my-profile`}
            onClick={(e) =>
              !isLogin
                ? () => {}
                : eventClickUpdateProfileLoyalti({
                    name: userData?.name.toLowerCase(),
                    no_hp: userData?.phoneNumber
                      ?.replace(/^(\+62|62)/, '0')
                      .replace(/ /g, '')
                      .replace(/^(?!0)/, '0'),
                    email: userData?.email || 'not available',
                    eventAction: 'lengkapi informasi profile',
                    eventName: 'lengkapi_profile_button',
                  })
            }
          >
            <div className="flex gap-3">
              {isLogin ? (
                <FillProfileIcon size={18} />
              ) : (
                <FillProfileIconDisabled width="18" height="18" />
              )}

              <div className="flex flex-col gap-1">
                <span
                  className={`font-bold text-xs text-start ${isLogin ? 'text-[#4F4C4D]' : 'text-reliableBlack50'}`}
                >
                  Lengkapi informasi profile
                </span>
                <span
                  className={`text-xs text-start ${isLogin ? 'text-[#7B7979]' : 'text-reliableBlack50'}`}
                >
                  Isi semua data profile Anda
                </span>
              </div>
            </div>
            <div className="my-auto">
              <Arrow
                direction="right"
                color={isLogin ? 'black' : '#BDBCBC'}
                size={18}
                fillOpacity={isLogin ? 0.54 : 1}
              />
            </div>
          </Link>
        )}
        {!isAstrapayConnected && (
          <Link
            className={`flex p-3 justify-between border-[1px] rounded-lg cursor-pointer ${!isLogin && 'bg-reliableBlack5 !cursor-not-allowed'}`}
            aria-disabled={!isLogin}
            href={!isLogin ? '#' : `${PUBLIC_URL}/astrapay/linking-account`}
            onClick={(e) =>
              !isLogin
                ? () => {}
                : eventClickUpdateProfileLoyalti({
                    name: userData?.name.toLowerCase(),
                    eventName: 'hubungkan_astrapay_button',
                    eventCategory: 'loyalty digiroom',
                    eventAction: 'hubungkan astrapay',
                    no_hp: userData?.phoneNumber
                      ?.replace(/^(\+62|62)/, '0')
                      .replace(/ /g, '')
                      .replace(/^(?!0)/, '0'),
                    email: userData?.email,
                  })
            }
          >
            <div className="flex gap-3">
              {isLogin ? (
                <AstraPayLogo height={16} width={18} />
              ) : (
                <AstraPayLogoDisabled height="16" width="18" />
              )}

              <div className="flex flex-col gap-1">
                <span
                  className={`font-bold text-xs text-start ${isLogin ? 'text-[#4F4C4D]' : 'text-reliableBlack50'}`}
                >
                  Hubungkan akun Astrapay
                </span>
                <span
                  className={`text-xs text-start ${isLogin ? 'text-[#7B7979]' : 'text-reliableBlack50'}`}
                >
                  Gunakan nomor terverifikasi Digiroom
                </span>
              </div>
            </div>
            <div className="my-auto">
              <Arrow
                direction="right"
                color={isLogin ? 'black' : '#BDBCBC'}
                size={18}
                fillOpacity={isLogin ? 0.54 : 1}
              />
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}

const TriangleBannerTop = () => {
  return (
    <svg
      width="198"
      height="48"
      viewBox="0 0 198 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: 'multiply' }}>
        <path d="M198 48V0H0L198 48Z" fill="#F3F3F3" />
      </g>
    </svg>
  );
};

const TriangleBannerBottom = () => {
  return (
    <svg
      width="91"
      height="102"
      viewBox="0 0 91 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.4">
        <path d="M91 0V108H0L91 0Z" fill="#C3C3CA" />
      </g>
    </svg>
  );
};
